'use client'

import { memo } from 'react'
import { useReducedMotion } from 'framer-motion'

/** Topographic civic backdrop: distinct from enterprise orbit/grid hero */
export const NinxlGovtsHeroBackground = memo(function NinxlGovtsHeroBackground() {
  const shouldReduce = useReducedMotion()

  return (
    <div className="ninxl-hero-bg pointer-events-none fixed inset-0 -z-10 overflow-hidden" aria-hidden>
      <div className="ninxl-theme-atmosphere-bg absolute inset-0" />
      <div className="ninxl-govts-topo-bg absolute inset-0 opacity-70" />
      {!shouldReduce ? <div className="ninxl-govts-scanlines absolute inset-0" /> : null}
      <div className="absolute inset-x-0 top-0 h-[55vh] bg-gradient-to-b from-[#21728d]/[0.07] via-transparent to-transparent" />
      <div className="ninxl-hero-bg-fade absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[color:var(--ninxl-theme-atmosphere)]" />
    </div>
  )
})